import withAuth from '../src/app-state/auth';
import ForgotPasswordPageV2 from '../src/auth/ForgotPasswordV2';

export default withAuth(ForgotPasswordPageV2);
